import React, { FC, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import cn from "classnames";
import ClearIcon from "@mui/icons-material/Clear";
import { changeToParams } from "Shared/Utils/search-params";
import style from "../ModalFilters/ModalOptions.module.scss";
import { durationRanges, quarterRanges } from "./constant";
import { DownArrowIcon, DropdowSnIcon } from "Assets";

type QuarterRangeProps = {
  fromParamName?: string;
  toParamName?: string;
  rangeParamName?: string;
  isDurationRanges?: boolean;
};

const QuarterRange: FC<QuarterRangeProps> = ({
  fromParamName = "from",
  toParamName = "to",
  isDurationRanges = false,
  rangeParamName = "range",
}) => {
  const [openModal, setOpenModal] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const toggleModal = () => setOpenModal(!openModal);
  const [searchParams, setSearchParams] = useSearchParams();
  const [chosenRangeTitle, setChosenRangeTitle] = useState<string>(
    searchParams.get(rangeParamName) || ""
  );

  const onChooseRange = (label: string, from: string, to: string) => {
    setChosenRangeTitle(label);
    setSearchParams(changeToParams(fromParamName, from, searchParams));
    setSearchParams(changeToParams(toParamName, to, searchParams));
    setSearchParams(changeToParams(rangeParamName, label, searchParams));
    searchParams.delete("date_range");
    setSearchParams(searchParams);
  };

  const clearInput = () => {
    setChosenRangeTitle("");
    searchParams.delete(fromParamName);
    searchParams.delete(toParamName);
    searchParams.delete(rangeParamName);
    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (!searchParams.has(fromParamName)) {
      setChosenRangeTitle("");
    }
  }, [searchParams, fromParamName]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setOpenModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={style.blockFiltering}>
      <div
        onClick={toggleModal}
        className={cn(
          style.blockFiltering__blockText,
          searchParams.has(rangeParamName) &&
            style.blockFiltering__blockText_selected
        )}
      >
        {chosenRangeTitle && searchParams.has(rangeParamName) ? (
          <div className={style.blockFiltering__blockText__val}>
            <p>{chosenRangeTitle}</p>
            <ClearIcon
              className={style.blockFiltering__blockText__val__icon}
              onClick={clearInput}
            />
          </div>
        ) : (
          <p>Select range</p>
        )}
        <DropdowSnIcon className={cn(style.icon, style.iconDefault)} />
        <DownArrowIcon className={cn(style.icon, style.iconLight)} />
      </div>
      {openModal && (
        <div ref={modalRef} className={style.blockFiltering__trueModal}>
          <div className={style.blockFiltering__trueModal__inModal}>
            <div
              className={style.blockFiltering__trueModal__inModal__paddingModal}
            >
              {isDurationRanges
                ? durationRanges?.map((el, index) => (
                    <li
                      onClick={() => onChooseRange(el.label, el.from, el.to)}
                      key={index}
                      className={cn(
                        style.blockFiltering__trueModal__inModal__paddingModal__listItem,
                        searchParams.get(rangeParamName) === el.label &&
                          style.activeItem
                      )}
                    >
                      {el.label}
                    </li>
                  ))
                : quarterRanges.map((el, index) => (
                    <li
                      onClick={() => onChooseRange(el.label, el.from, el.to)}
                      key={index}
                      className={cn(
                        style.blockFiltering__trueModal__inModal__paddingModal__listItem,
                        searchParams.get(rangeParamName) === el.label &&
                          style.activeItem
                      )}
                    >
                      {el.label}
                    </li>
                  ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuarterRange;
